window.nojscode=!0